export default class SideMenu {
  sideMenu;
  openToggleButtons;
  closeToggleButtons;
  toggleButtons;

  constructor(sideMenu) {
    this.sideMenu = sideMenu;
    this.openToggleButtons = document.getElementsByClassName('side-menu-open');
    this.closeToggleButtons = document.getElementsByClassName('side-menu-close');
    this.toggleButtons = document.getElementsByClassName('side-menu-toggle');
    this.bindListeners();
  }

  bindListeners() {
    for( let openToggle of this.openToggleButtons ) {
      openToggle.addEventListener('click', this.open.bind(this));
    }

    for( let closeToggle of this.closeToggleButtons ) {
      closeToggle.addEventListener('click', this.close.bind(this));
    }
  }

  open() {
    this.sideMenu.classList.add('open');
  }

  close() {
    this.sideMenu.classList.remove('open');
  }

  toggle() {
    if(!this.sideMenu.classList.contains('open')) {
      this.open();
    }
    else {
      this.close();
    }
  }
}


// WEBPACK FOOTER //
// ../w-theme/ui/assets/js/components/SideMenu/SideMenu.js